import React from 'react';

function ManagesSupportPage() {
    return <div>ManagesSupportPage</div>;
}

export default ManagesSupportPage;
